import { ReactNode } from 'react';

interface OneliveSubPageLayoutProps {
  title: string;
  children: ReactNode;
}

/** FAQ / 공지사항 등 서브 페이지 공통 레이아웃 (사이드바 없음, 배너 + 중앙 컨텐츠) */
export default function OneliveSubPageLayout({ title, children }: OneliveSubPageLayoutProps) {
  return (
    <section className="onelive-sub-page">
      <h1 className="onelive-sub-page-sr-title">{title}</h1>
      <div className="onelive-sub-banner">
        <h2>{title}</h2>
      </div>
      <div className="onelive-sub-container">{children}</div>
    </section>
  );
}
